import { render, staticRenderFns } from "./myFooter.vue?vue&type=template&id=5f9df6e4&scoped=true"
import script from "./myFooter.vue?vue&type=script&lang=js"
export * from "./myFooter.vue?vue&type=script&lang=js"
import style0 from "./myFooter.vue?vue&type=style&index=0&id=5f9df6e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9df6e4",
  null
  
)

export default component.exports